/**
 * Fix for exam_id issues in various API functions
 */

// Import this in main.js and apply before other fixes
export default function fixExamIdApi(api) {
  // Preserve original functions
  const originalFunctions = {};

  // Simple wrapper to ensure exam_id is properly formatted as a number
  const wrapWithExamId = (functionName) => {
    if (typeof api[functionName] === 'function') {
      // Save the original function
      originalFunctions[functionName] = api[functionName];

      // Replace with our fixed version
      api[functionName] = function(...args) {
        console.log(`Exam ID Fix: ${functionName} called with args:`, args);

        // Check if first argument is an object with exam_id
        if (args.length > 0 && args[0] && typeof args[0] === 'object' && 'exam_id' in args[0]) {
          if (typeof args[0].exam_id === 'string') {
            // Convert to number
            args[0].exam_id = parseInt(args[0].exam_id, 10);
            console.log(`Converted exam_id to number: ${args[0].exam_id}`);
          }
        }

        // Call the original function
        return originalFunctions[functionName].apply(this, args);
      };
    }
  };

  // Apply the wrapper to relevant functions
  wrapWithExamId('createDiagnosticCase');
  wrapWithExamId('updateDiagnosticCase');
  wrapWithExamId('getDiagnosticCases');
  wrapWithExamId('getDiagnosticCase');

  // Return the modified API
  return api;
}